/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_TitleInputs */



/**
* | output |
* | --- |
* | "Auto Format Events" |
*
* @param {Auto_Format_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_title = /** @type {((inputs?: Auto_Format_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise en Forme Automatique des Evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierungsereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi di formattazione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos de formato automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式化事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの自動フォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित प्रारूप घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática de eventos")
	return /** @type {LocalizedString} */ ("Auto Format Events")
});